require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-facebook-dropped-the-ball.json") })
        }
      }, "path---news-facebook-dropped-the-ball");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-facebook-dropped-the-ball!./.cache/json/news-facebook-dropped-the-ball.json
// module id = 1420
// module chunks = 231608221292675